import {
    REQUEST_KYC_INITIALIZE,
    SUCCESS_KYC_INITIALIZE,
    FAILURE_KYC_INITIALIZE,
    REQUEST_KYC_STATE,
    SUCCESS_KYC_STATE,
    FAILURE_KYC_STATE,
    RESET_KYC_STATE
} from './constants';
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';
import { makeActionCreator } from '../../utils/actionsUtils';

export const reset = makeActionCreator(RESET_KYC_STATE);

export function initializeKyc(email, userId, clickId, kycRequest) {
    let plebicardUrl = `/public/payment-solution/checkout/kyc?email=${email}`;
    plebicardUrl = userId ? plebicardUrl.concat(`&userId=${userId}`) : plebicardUrl;
    plebicardUrl = clickId ? plebicardUrl.concat(`&clickId=${clickId}`) : plebicardUrl;

    return {
        [CALL_API]: {
            endpoint: plebicardUrl,
            method: HTTP_METHOD_POST,
            body: { ...kycRequest },
            types: [REQUEST_KYC_INITIALIZE, SUCCESS_KYC_INITIALIZE, FAILURE_KYC_INITIALIZE]
        }
    };
}

export const fetchKycState = (email, userId, clickId) => {
    let plebicardUrl = `/public/payment-solution/checkout/kyc/state?email=${email}`;
    plebicardUrl = userId ? plebicardUrl.concat(`&userId=${userId}`) : plebicardUrl;
    plebicardUrl = clickId ? plebicardUrl.concat(`&clickId=${clickId}`) : plebicardUrl;

    return {
        [CALL_API]: {
            endpoint: plebicardUrl,
            types: [REQUEST_KYC_STATE, SUCCESS_KYC_STATE, FAILURE_KYC_STATE],
            method: HTTP_METHOD_GET
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/kyc/actions.js